import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden font-badge",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90 yahoo-default",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90 yahoo-secondary",
        destructive:
          "border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60 yahoo-destructive",
        outline:
          "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground yahoo-outline",
        // Custom variant: success
        success:
          "border-transparent bg-success text-success-foreground [a&]:hover:bg-success/90 yahoo-success",
        // Custom variants
        warning:
          "border-transparent bg-warning text-warning-foreground [a&]:hover:bg-warning/90 yahoo-warning",
        info: "border-transparent bg-info text-info-foreground [a&]:hover:bg-info/90 yahoo-info",
        neutral:
          "border-transparent bg-neutral text-neutral-foreground [a&]:hover:bg-neutral/90 yahoo-neutral",
        highlight:
          "border-transparent bg-highlight text-highlight-foreground [a&]:hover:bg-highlight/90 yahoo-highlight",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);
